export default "__VITE_ASSET__qKApsPAX__ 960w, __VITE_ASSET__58VoO7ok__ 1440w";